// 【公共組件】意見與反饋
export default {
    'feedback.name': '意見反饋',
    'feedback.upload': '上傳圖片',
}
 